<template>
  <DashboardTemplate :navMenu="true">
    <div class="text-left pd-b-3">
      <h2 class="mg-less">จัดการข้อมูลทั่วไป</h2>
    </div>
    <el-tabs v-model="activeName" class="secondary">
      <el-tab-pane label="จัดการภาพแบนเนอร์หน้าเริ่มต้น" name="1">
        <div v-loading="loading">
          <ManageGeneralBanner
            :imageBanner="imageBanner"
            @saveGeneralInfornation="saveGeneralInfornation"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="จัดการใบประกาศนียบัตร" name="2">
        <div v-loading="loading">
          <ManageGeneralCertificate
            :image="signatureImage"
            :name="signatureName"
            :position="signaturePosition"
            @saveGeneralInfornation="saveGeneralInfornation"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ManageGeneralBanner from "@/components/manageGeneral/ManageGeneralBanner";
import ManageGeneralCertificate from "@/components/manageGeneral/ManageGeneralCertificate";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    ManageGeneralBanner,
    ManageGeneralCertificate,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      activeName: "1",
      loading: true,
      imageBanner: [],
      signatureImage: null,
      signatureName: "",
      signaturePosition:""
    };
  },
  mounted() {
    this.fetchGeneral();
  },
  methods: {
    fetchGeneral() {
      HTTP.get(`get/general`)
        .then((res) => {
          if (res.data.success && res.data.obj) {
            this.imageBanner =
              typeof res.data.obj.images != "undefined"
                ? res.data.obj.images
                : [];
            this.signatureImage =
              typeof res.data.obj.imgInformation != "undefined"
                ? res.data.obj.imgInformation
                : null;

            this.signatureName =
              typeof res.data.obj.personSign != "undefined"
                ? res.data.obj.personSign
                : "";

            this.signaturePosition =
              typeof res.data.obj.position != "undefined"
                ? res.data.obj.position
                : "";
          }
        })
        .catch((e) => {
          console.log("fetchGeneral error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    saveGeneralInfornation(data) {
      this.loading = true;

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();

      if (typeof data.signName != 'undefined') {
        formData.append("personSign", data.signName);
      }

      if (typeof data.position != 'undefined') {
        formData.append("position", data.position);
      }

      if (typeof data.image != 'undefined') {
        formData.append("image", data.image);
      }

      if (typeof data.delImage != 'undefined') {
        formData.append("delImage", data.delImage);
      }

      if (typeof data.signatureimage != 'undefined' && data.signatureimage) {
        formData.append("imgInformation", data.signatureimage);
      }

      if (typeof data.delSignature != 'undefined' && data.delSignature) {
        formData.append("delSignature", data.delSignature);
      }

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`general/information`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.fetchGeneral();
          } else {
            this.loading = false;
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          this.loading = false;
          console.log("saveGeneralInfornation error", e);
        });
    },
  },
};
</script>

<style scoped>
</style>
